export const SEVERITY = "severity";
export const SUMMARY_MESSAGE = "summaryMessage";
export const DETAIL_MESSAGE = "detailMessage";
export const SUCCESS_SEVERITY = "success";
export const ERROR_SEVERITY = "error";
export const SUCCESS_SUMMARY_MESSAGE_KEY = "common.success";
export const ERROR_SUMMARY_MESSAGE_KEY = "common.error";
